var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMapIconMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.473,
    height: 30.474,
    viewBox: "0 0 31.473 30.474",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ukhgkz0h0a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 205",
    style: {
      fill: "none",
      stroke: "#222"
    },
    d: "M0 0h31.473v30.474H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 499"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 343",
    style: {
      clipPath: "url(#ukhgkz0h0a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 203",
    d: "m30.974 22.53-9.792 6.744-10.033-6.744L.5 29.723V8.142L11.149.949l10.033 6.744L30.974.949l.1 21.581",
    transform: "translate(-.05 -.095)",
    style: {
      strokeMiterlimit: 10,
      fill: "none",
      stroke: "#222"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 147",
    transform: "translate(11.099 .853)",
    style: {
      strokeMiterlimit: 10,
      fill: "none",
      stroke: "#222"
    },
    d: "M0 0v21.581"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 148",
    transform: "translate(21.132 7.148)",
    style: {
      strokeMiterlimit: 10,
      fill: "none",
      stroke: "#222"
    },
    d: "M0 0v22.031"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIconMobile);
export default __webpack_public_path__ + "static/media/map-icon-mobile.0f32d2bab4080da190f71ab8db868700.svg";
export { ForwardRef as ReactComponent };